/**
 * @file index.tsx
 * @module Index
 * @description Karšu pārlūka ieejas punkts. Konfigurē React Router ar četriem maršrutiem:
 *              - "/" (galvenā kartes lietotne)
 *              - "/UIkit" (UI komponenšu bibliotēka/demonstrācija)
 *              - "/mini" (atsevišķa marķieru forma iegulšanai SIPR sistēmas priekšpuses servisā)
 *              - "/public" (publiskā iegultā karte ar MapLibre GL ārējām vietnēm)
 *              Inicializē Matomo analītikas izsekošanu un Ant Design stilu nodrošinātāju.
 */

import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { StyleProvider } from "@ant-design/cssinjs";
import ErrorPage from "./Error-page";
import UiKit from "./shared/UI kit/UIkit";
import { MapMarkerForm } from "./map-marker/Map-marker-form";
import EmbedMapWrapper from "./embed/embed-map/embed-map";
import { useMatomo } from "./map-marker/useMatomo";

/**
 * Client-side router configuration.
 *
 * Routes:
 * - `/` - Full interactive map (OpenLayers + Mapbox base layers)
 * - `/UIkit` - Internal design system component showcase
 * - `/mini` - Standalone marker editor (embedded in SIPR event forms via iframe)
 * - `/public` - Lightweight public embed map (MapLibre GL, no authentication required)
 */
const router = createBrowserRouter([
	{ path: "/", element: <App />, errorElement: <ErrorPage /> },
	{ path: "/UIkit", element: <UiKit />, errorElement: <ErrorPage /> },
	{ path: "/mini", element: <MapMarkerForm />, errorElement: <ErrorPage /> },
	{ path: "/public", element: <EmbedMapWrapper />, errorElement: <ErrorPage /> },
]);

/**
 * Root wrapper component.
 *
 * Initializes Matomo analytics on mount (production only) and provides
 * Ant Design's StyleProvider with high hash priority to ensure correct
 * CSS specificity when combined with Tailwind CSS.
 */
function Root() {
	useMatomo();
	return (
		<StyleProvider hashPriority="high">
			<RouterProvider router={router} />
		</StyleProvider>
	);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Root />);
